import useSecurity from "../../../../use/useSecurity";
import useEntrepreneurRepository from "../../../../repository/user/useEntrepreneurRepository";
import {useEffect} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {Alert, CircularProgress} from "@mui/material";
import useCompanyRepository from "../../../../repository/user/useCompanyRepository";
import {useNavigate} from "react-router";
import Body from "../../../../material/skeleton/Body";
import Tab from "../../../../material/tab/Tab";
import TabConfig from "../../../../material/tab/TabConfig";
import TabUnity from "../../../../material/tab/TabUnity";
import SosPagination from "./SosPagination";
import B2cPagination from "./B2cPagination";
import Typography from "@mui/material/Typography";
import {Announcement} from "@mui/icons-material";
import B2csduPagination from "./B2csduPagination";
import InsurancePagination from "./InsurancePagination";

export default function () {
    const security = useSecurity();
    const navigate = useNavigate();
    const entrepreneurRepository = useEntrepreneurRepository();
    const companyRepository = useCompanyRepository();
    /** @type Entrepreneur */
    const entrepreneur = entrepreneurRepository.findOneById(security.id).select();
    /** @type Company */
    const company = companyRepository.findOneById(entrepreneur?.getCompanyId()).select();

    useEffect(() => {
        entrepreneurRepository.findOneById(security.id).exec();
    }, []);

    useEffect(() => {
        if (isNull(entrepreneur)) return;

        companyRepository.findOneById(entrepreneur?.getCompanyId()).exec();
    }, [JSON.stringify(entrepreneur)]);


    if (isNull(entrepreneur)) {
        return (
            <Box mt={20} display="flex" justifyContent="center">
                <CircularProgress/>
            </Box>
        );
    }

    return (
        <Body hasFooter={false}>
            <Box mt={1} px={2}>
                <Alert severity={"warning"} icon={<Announcement/>}>
                    Il est indispensable que vous fassiez l'application&nbsp;
                    <Typography fontWeight={"bold"} display="inline">en temps réel</Typography> et que vous
                    respectiez&nbsp;
                    <Typography fontWeight={"bold"} display="inline">rigoureusement chaque étape demandée</Typography>.
                </Alert>
            </Box>
            <Box mt={2} px={1}>
                <Tab
                    tabConfig={
                        new TabConfig()
                            .setWithPersistence(true, "pagination-entrepreneur")
                            .addTabUnity(
                                new TabUnity()
                                    .setName("SOS")
                                    .setPadding(0)
                                    .setComponent(<SosPagination companyId={entrepreneur.getCompanyId()}/>)
                            )
                            .addTabUnity(
                                new TabUnity()
                                    .setName("B2C")
                                    .setPadding(0)
                                    .setComponent(<B2cPagination companyId={entrepreneur.getCompanyId()}/>)
                            )
                            .addTabUnity(
                                new TabUnity()
                                    .setName("TRAVAUX")
                                    .setPadding(0)
                                    .setComponent(<B2csduPagination companyId={entrepreneur.getCompanyId()}/>)
                            )
                            .addTabUnity(
                                new TabUnity()
                                    .setName("ASSURANCE")
                                    .setPadding(0)
                                    .setComponent(<InsurancePagination companyId={entrepreneur.getCompanyId()}/>)
                            )
                    }
                />

            </Box>
        </Body>
    )
}